import { createAction } from '@reduxjs/toolkit';

import { DownloadAccountStatementPdfSuccessPayload } from 'store/account/actions.types';

import {
    CLEAR_TRANSACTIONS_LIST,
    DELETE_RECEIPT,
    DELETE_RECEIPT_FAILURE,
    DELETE_RECEIPT_SUCCESS,
    DeleteReceiptPayload,
    DeleteReceiptSuccessPayload,
    DOWNLOAD_RECEIPT_ATTACHMENT,
    DOWNLOAD_RECEIPT_ATTACHMENT_FAILURE,
    DOWNLOAD_RECEIPT_ATTACHMENT_SUCCESS,
    DownloadReceiptAttachmentFailurePayload,
    DownloadReceiptAttachmentPayload,
    FETCH_TRANSACTION_DETAILS,
    FETCH_TRANSACTION_DETAILS_FAILURE,
    FETCH_TRANSACTION_DETAILS_SUCCESS,
    FETCH_TRANSACTIONS_LIST,
    FETCH_TRANSACTIONS_LIST_FAILURE,
    FETCH_TRANSACTIONS_LIST_SUCCESS,
    HIDE_DOWNLOAD_RECEIPT_ATTACHMENT_FORM,
    HideDownloadReceiptAttachmentFormPayload,
    SHOW_DOWNLOAD_RECEIPT_ATTACHMENT_FORM,
    ShowDownloadReceiptAttachmentFormPayload,
} from './actions.types';


export const fetchTransactionsList = createAction(
    FETCH_TRANSACTIONS_LIST,
    ({ queryParams, locationPathname }) => ({ payload: { queryParams, locationPathname } }),
);
export const fetchTransactionsListSuccess = createAction(
    FETCH_TRANSACTIONS_LIST_SUCCESS,
    ({ items, totalCount, locationPathname }) => ({ payload: { items, totalCount, locationPathname } }),
);
export const fetchTransactionsListFailure = createAction(
    FETCH_TRANSACTIONS_LIST_FAILURE,
    ({ locationPathname }) => ({ payload: { locationPathname } }),
);
export const clearTransactionsList = createAction(
    CLEAR_TRANSACTIONS_LIST,
    ({ locationPathname }) => ({ payload: { locationPathname } }),
);


export const fetchTransactionDetails = (payload: { id: string }) => ({
    type: FETCH_TRANSACTION_DETAILS,
    payload,
});

export const fetchTransactionDetailsSuccess = (payload: any) => ({
    type: FETCH_TRANSACTION_DETAILS_SUCCESS,
    payload,
});

export const fetchTransactionDetailsFailure = (payload: any) => ({
    type: FETCH_TRANSACTION_DETAILS_FAILURE,
    payload,
});

export const deleteReceipt = createAction(
    DELETE_RECEIPT,
    ({ queryParams, locationPathname }: DeleteReceiptPayload) => ({ payload: { queryParams, locationPathname } }),
);
export const deleteReceiptSuccess = createAction(
    DELETE_RECEIPT_SUCCESS,
    ({ responsePayload }: DeleteReceiptSuccessPayload) => ({ payload: responsePayload }),
);
export const deleteReceiptFailure = createAction(DELETE_RECEIPT_FAILURE);

export const showDownloadReceiptAttachmentForm = createAction(
    SHOW_DOWNLOAD_RECEIPT_ATTACHMENT_FORM,
    (payload: ShowDownloadReceiptAttachmentFormPayload) => ({ payload }),
);
export const hideDownloadReceiptAttachmentForm = createAction(
    HIDE_DOWNLOAD_RECEIPT_ATTACHMENT_FORM,
    (payload: HideDownloadReceiptAttachmentFormPayload) => ({ payload }),
);

export const downloadReceiptAttachment = createAction(
    DOWNLOAD_RECEIPT_ATTACHMENT,
    ({ queryParams }: DownloadReceiptAttachmentPayload) => ({ payload: { queryParams } }),
);
export const downloadReceiptAttachmentSuccess = createAction(
    DOWNLOAD_RECEIPT_ATTACHMENT_SUCCESS,
    (payload: DownloadAccountStatementPdfSuccessPayload) => ({ payload }),
);
export const downloadReceiptAttachmentFailure = createAction(
    DOWNLOAD_RECEIPT_ATTACHMENT_FAILURE,
    (payload: DownloadReceiptAttachmentFailurePayload) => ({ payload }),
);
